import React, { useState, useCallback } from "react";
import { useIntl } from "react-intl";
import FormWrapper from "./FormWrapper";
import { Row, Col, Button, Collapse } from "antd";
import { InputItem, TextAreaItem } from "../../../forms/FormItems";
import { useSelector } from "react-redux";
import { actionTypes, activityStatuses, activityTypes } from "../../constants";
import moment from "moment";

const { Panel } = Collapse;

const Log = ({
  createActivity,
  statuses,
  refreshFormTimestamp,
  collapsed,
  stretched,
}) => {
  const intl = useIntl();
  const [collapsedKeys, setCollapsedKeys] = useState(null);
  const profileId = useSelector((state) => state.user.profile.user);
  const createLoading = useSelector(
    (state) => state.pendingActions[actionTypes.ACTIVITY_CREATE]
  );

  const onChange = useCallback((keys) => {
    setCollapsedKeys(keys);
  }, []);

  const onSubmit = (values) => {
    const status = statuses.find(
      (i) => i.name === activityStatuses.ACTIVITIES_STATUS_COMPLETAED
    );
    const activity = {
      ...values,
      type: activityTypes.ACTIVITIES_TYPE_CALL,
      due_date: moment().format(),
      assigned_to_id: profileId,
      status_id: status?.id,
    };

    createActivity({
      activity,
      activityType: activityTypes.ACTIVITIES_TYPE_TASKS,
    });
  };

  const colSettings = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: stretched ? 24 : 16,
  };

  return (
    <div className="activity_form">
      <FormWrapper
        onSubmit={onSubmit}
        refreshFormTimestamp={refreshFormTimestamp}
      >
        {collapsed ? (
          <div style={{ padding: "12px" }}>
            <Row>
              <Col {...colSettings}>
                <InputItem name="subject" category="log" required />
                <TextAreaItem name="body" category="log" rows={4} />
                <Button
                  htmlType="submit"
                  type="primary"
                  loading={createLoading}
                >
                  {intl.formatMessage({ id: "app.actions.submit" })}
                </Button>
              </Col>
            </Row>
          </div>
        ) : (
          <Row>
            <Col {...colSettings}>
              <Collapse
                ghost
                onChange={onChange}
                className="activity-collpase-form"
              >
                <Panel
                  showArrow={false}
                  header={<InputItem name="subject" category="log" required />}
                  key="1"
                  collapsible={collapsedKeys ? "disabled" : ""}
                >
                  <TextAreaItem name="body" category="log" rows={4} />
                  <Button
                    htmlType="submit"
                    type="primary"
                    loading={createLoading}
                  >
                    {intl.formatMessage({ id: "app.actions.submit" })}
                  </Button>
                </Panel>
              </Collapse>
            </Col>
          </Row>
        )}
      </FormWrapper>
    </div>
  );
};

export default Log;
